export default "__VITE_ASSET__BGYI8qn___"